import firebase from 'firebase/app';
import Vue from 'vue';
import 'firebase/firestore';
const state = {
  enable_transactions: false,
  transaction_amount: null,
  service_fee_percentage: null,
  signature_required: false,
  requestload_fee: null,
  account_type: null,
};
const mutations = {
  set_enabled_transactions(state, payload) {
    state.enable_transactions = payload;
  },
  set_transaction_amount(state, payload) {
    state.transaction_amount = payload;
  },
  set_service_fee_percentage(state, payload) {
    state.service_fee_percentage = payload;
  },
  set_signature_required(state, payload) {
    state.signature_required = payload;
  },
  set_requestload_fee(state, payload) {
    state.requestload_fee = payload;
  },
  set_account_data(state, payload) {
    state.account_type = payload;
  },
};
const actions = {
  async get_payment_settings_data({ commit, dispatch }, payload) {
    Vue.prototype.$snapshots.$payment_settings_snapshot = await firebase
      .firestore()
      .collection('settings')
      .doc('payments')
      .onSnapshot((doc) => {
        commit('set_enabled_transactions', doc.data().enableTransactions);
        commit('set_transaction_amount', doc.data().transactionAmount);
        commit('set_service_fee_percentage', doc.data().serviceFeePercentage);
      });
  },
  async get_marketplace_settings_data({ commit, dispatch }, payload) {
    Vue.prototype.$snapshots.$marketplace_settings_snapshot = await firebase
      .firestore()
      .collection('settings')
      .doc('marketplace')
      .onSnapshot((doc) => {
        commit('set_signature_required', doc.data().signatureRequired);
      });
  },

  async get_requestload_settings_data({ commit, dispatch }) {
    Vue.prototype.$snapshots.$marketplace_settings_snapshot = await firebase
      .firestore()
      .collection('settings')
      .doc('request_loads')
      .onSnapshot((doc) => {
        commit('set_requestload_fee', doc.data());
      });
  },

  async get_account_type({ commit, dispatch }) {
    const doc = await firebase
      .firestore()
      .collection('settings')
      .doc('account_type')
      .get();

    commit('set_account_data', doc.data());
  },
  // async get
};
const getters = {
  get_is_enabled_transactions(state) {
    return state.enable_transactions;
  },
  get_transaction_amount(state) {
    return state.transaction_amount;
  },
  get_service_fee_percentage(state) {
    return state.service_fee_percentage;
  },
  get_is_signature_required(state) {
    return state.signature_required;
  },
  get_request_load_fee(state) {
    return state.requestload_fee;
  },
  get_account_type_data(state) {
    return state.account_type;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
